import axios from "axios"
import configData from "../appsettings.json"

export function addEvent(data, Idtoken) {
    return axios.post(`${configData.baseUrl}/SqlEvents/CreateEvent`, JSON.stringify(data), {
        headers : {
            'X-Firebase-Authorization' : Idtoken,
            'Content-Type': 'application/json',
            'Accept': 'application/json, text/plain, */*',
        }
    })
}

export function getEventTypeCounts(Idtoken) {
    return axios.get(`${configData.baseUrl}/SqlStats/GetEventTypeCounts`, {
        headers : {
            'X-Firebase-Authorization' : Idtoken,
            'Content-Type': 'application/json',
            'Accept': 'application/json, text/plain, */*',
        }
    })
}

export function getEventsByVenueId(id, Idtoken){
    return axios.get(`${configData.baseUrl}/SqlEvents/GetEvents?venueId=${id}`, {
        headers : {
            'X-Firebase-Authorization' : Idtoken,
            'Content-Type': 'application/json',
            'Accept': 'application/json, text/plain, */*',
        }
    })
}

export function getEventByEventId(id, Idtoken){
    return axios.get(`${configData.baseUrl}/SqlEvents/GetEventDetails?eventId=${id}`, {
        headers : {
            'X-Firebase-Authorization' : Idtoken,
            'Content-Type': 'application/json',
            'Accept': 'application/json, text/plain, */*',
        }
    })
}

export function deleteEventById(id, Idtoken){
    return axios.delete(`${configData.baseUrl}/SqlEvents/DeleteEvent?eventId=${id}`, {
        headers : {
            'X-Firebase-Authorization' : Idtoken,
            'Content-Type': 'application/json',
            'Accept': 'application/json, text/plain, */*',
        }
    })
}

export function updateEvent(data, Idtoken) {
    return axios.put(`${configData.baseUrl}/SqlEvents/UpdateEvent`, JSON.stringify(data), {
        headers : {
            'X-Firebase-Authorization' : Idtoken,
            'Content-Type': 'application/json',
            'Accept': 'application/json, text/plain, */*',
        }
    })
}


